var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "IconLinkItem",
                _vm._g(
                  {
                    key: "exportCaat",
                    attrs: { text: "CAAT Spreadsheet", icon: "mdi-file-excel" },
                    on: {
                      click: function ($event) {
                        return _vm.exportCaat()
                      },
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Compliance Assessment Audit Tracking Data")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }